/**
 * Popup animations.
 */
import { ModalProps } from 'react-native-modal';

export const animationIn: ModalProps['animationIn'] = {
  0: {
    opacity: 0.5,
    scale: 0.5,
  },
  0.7: {
    opacity: 1,
    scale: 1,
  },
  0.9: {
    scale: 1.03,
  },
  1: {
    opacity: 1,
    scale: 1,
  },
} as never;

export const animationOut: ModalProps['animationOut'] = {
  0: {
    opacity: 1,
    scale: 1,
    translateY: 0,
  },
  0.5: {
    opacity: 0.5,
    scale: 0.5,
    translateY: -1000,
  },
  1: {
    opacity: 0,
    scale: 0,
  },
} as never;

export const FadeIn = {
  from: {
    opacity: 0,
    transform: 'scale(0.9)',
  },
  enter: {
    opacity: 1,
    transform: 'scale(1)',
  },
  leave: {
    opacity: 0,
    transform: 'scale(0.9)',
  },
  unique: true,
  config: {
    mass: 1,
    tension: 170,
    friction: 26,
  },
};

export const SlideIn = {
  from: {
    opacity: 0.8,
    transform: 'translateY(200px)',
  },
  enter: {
    opacity: 1,
    transform: 'translateY(0px)',
  },
  leave: {
    opacity: 0,
    transform: 'translateY(200px)',
  },
  unique: true,
};
